import './IconDocument.css';
import React from 'react';
var IconDocument = function IconDocument(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 20 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 21 : _ref$height,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 20 20",
    className: "".concat(className, " ").concat(styles)
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M6.04163 13.9583H13.9583V12.7083H6.04163V13.9583ZM6.04163 10.625H13.9583V9.37496H6.04163V10.625ZM6.04163 7.29163H13.9583V6.04163H6.04163V7.29163ZM4.42308 17.0833C4.00211 17.0833 3.64579 16.9375 3.35413 16.6458C3.06246 16.3541 2.91663 15.9978 2.91663 15.5768V4.42308C2.91663 4.00211 3.06246 3.64579 3.35413 3.35413C3.64579 3.06246 4.00211 2.91663 4.42308 2.91663H15.5768C15.9978 2.91663 16.3541 3.06246 16.6458 3.35413C16.9375 3.64579 17.0833 4.00211 17.0833 4.42308V15.5768C17.0833 15.9978 16.9375 16.3541 16.6458 16.6458C16.3541 16.9375 15.9978 17.0833 15.5768 17.0833H4.42308ZM4.42308 15.8333H15.5768C15.641 15.8333 15.6998 15.8066 15.7531 15.7531C15.8066 15.6998 15.8333 15.641 15.8333 15.5768V4.42308C15.8333 4.35892 15.8066 4.30017 15.7531 4.24683C15.6998 4.19336 15.641 4.16663 15.5768 4.16663H4.42308C4.35892 4.16663 4.30017 4.19336 4.24683 4.24683C4.19336 4.30017 4.16663 4.35892 4.16663 4.42308V15.5768C4.16663 15.641 4.19336 15.6998 4.24683 15.7531C4.30017 15.8066 4.35892 15.8333 4.42308 15.8333Z"
  }));
};
var styles = "sqlfsru";
export default IconDocument;